class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.plusButton = document.querySelector('[data-quantity-button="plus"]');
    this.minusButton = document.querySelector('[data-quantity-button="minus"]');
    this.quantityInput = document.querySelector('input[name="quantity"]');

    this.maxQuantity = this.quantityInput.maxLength;

    this.handleQuantity = this.handleQuantity.bind(this);

    this.plusButton.addEventListener('click', this.handleQuantity);
    this.minusButton.addEventListener('click', this.handleQuantity);
  }

  disconnectedCallback() {
    this.quantityButtons.forEach(button => {
      button.removeEventListener('click', this.handleQuantity);
    })
  }

  handleQuantity(event) {
    const button = event.currentTarget;
    let currentQuantity = Number(this.quantityInput.value);
    let updatedQuantity;

    if (button.dataset.quantityButton === "minus") {
      updatedQuantity = Math.max(0, currentQuantity - 1);
      if (updatedQuantity === 0) {
        // show the plus button
        this.plusButton.dataset.visibility = "show"
        this.minusButton.dataset.visibility = "hidden";
      }
    } else if (button.dataset.quantityButton === "plus") {
      updatedQuantity = currentQuantity + 1;

      // check if the updatedQuantity reaches maxQuantity
      // maxQuantity will be -1 for Continue Sell items
      if (this.maxQuantity != -1 && updatedQuantity >= this.maxQuantity) {
        this.plusButton.dataset.visibility = "hidden";
        this.minusButton.dataset.visibility = "show";
      }
    }

    this.quantityInput.value = updatedQuantity;
  }
}

customElements.define('quantity-selector', QuantitySelector);
